<template>
  <div ref='model_date' class="model">
    <div v-if="form.id" class="articleBase">
      <div class="articleBase_title">{{form.title}}</div>
      <div v-if="form.author" class="color_art articleBase_address">作者：{{form.author}}</div>
      <div class="color_art articleBase_time">
        <span>发布时间：{{form.publish_time|time('YYYY-MM-DD HH:mm:ss')}}</span>
        <span><img src="@/assets/auto_img/view@2x (2).png" alt=""> {{form.view}}</span>
      </div>
      <div class="articleBase_content" v-html="form.content"></div>
    </div>
    <div v-if="!form.id" class="noMsg">
      <img src="@/assets/无内容.png" alt="">
      暂无内容...
    </div>
    <backhome :form="meeting_data"></backhome>
  </div>
</template>

<script>

import { getDocumentDet } from '@/api/meetApi.js';
import { getWXConfig } from "@/api/login.js";
import backhome from '@/components/backHome.vue';
import moment from "moment";
export default {
  components: { backhome },
  data() {
    return {
      form: {},
      meeting_data: {},
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    moment,
    async getDetail() {
      let meeting_id = this.$route.query.meeting_id
      let id = this.$route.query.id
      let data = await getDocumentDet({ meeting_id, id })
      this.form = data.payload.data
      document.title = this.form.title
      this.meeting_data = data.payload.meeting_data
      this.changeMobileBG()
      this.share()
    },
    changeMobileBG() {
      let domPhone = this.$refs.model_date

      if (this.form.is_enable_page_style == 2) {
        domPhone.style.background = '#FFF'
        return
      }

      if (this.form.page_style == 1) {
        domPhone.style.background = this.meeting_data.background_color
      } else if (this.form.page_style == 2) {
        domPhone.style.background = "url(" + this.meeting_data.background_img_path + ") ";
        domPhone.style.backgroundRepeat = 'no-repeat'
        domPhone.style.backgroundSize = '100% 100%'
      } else if (this.form.page_style == 3) {
        domPhone.style.background = "url(" + this.meeting_data.tail_img_path + ") ";
        domPhone.style.backgroundRepeat = 'no-repeat'
        domPhone.style.backgroundSize = '100% auto'
        domPhone.style.backgroundPosition = 'bottom'
      } else if (this.form.page_style == 4) {
        domPhone.style.background = "url(" + this.form.page_style_img_path + ") ";
        domPhone.style.backgroundRepeat = 'no-repeat'
        domPhone.style.backgroundSize = '100% 100%'
      }
    },
    async share() {
      // 判断是否有meeting_id，用于记录访问次数
      let data = null
      if (this.meeting_data && this.meeting_data.id) {
        data = await getWXConfig({ url: window.location.href, meeting_id: this.meeting_data.id })
      } else {
        data = await getWXConfig({ url: window.location.href })
      }

      let reg = /\\r\\n/ig
      // 优先使用自定义的分享配置，如果没有则使用大会得默认配置
      // 当所有参数都没有时，会在wxConfig.js中生成默认配置
      // 七个参数分别为（分享配置，聊天标题，聊天图片，聊天介绍，朋友圈标题，朋友圈图片，朋友圈介绍）
      // 分享链接在wxConfig.js中生成，为当前页面链接


      // 下边一堆配置，是为了在极端情况下分享能正常进行。 
      // 注意，当直播是直接在素材库创建时可能没有meeting_data，所以这里要判断一下
      let shareA = this.form.wechat_share_title ? this.form.wechat_share_title.replace(reg, "\r\n") : this.form.title
      let shareB = this.form.wechat_share_img_path ? this.form.wechat_share_img_path : ''
      if (!shareB && this.meeting_data && this.meeting_data.id) {
        shareB = this.meeting_data.wechat_share_img_path
      }
      let shareC = this.form.wechat_share_content ? this.form.wechat_share_content.replace(reg, "\r\n") : ''
      if (!shareC && this.meeting_data && this.meeting_data.id) {
        shareC = this.meeting_data.wechat_share_content
      }

      let shareD = this.form.moments_share_title ? this.form.moments_share_title.replace(reg, "\r\n") : this.form.title
      let shareE = this.form.moments_share_img_path ? this.form.moments_share_img_path : ''
      if (!shareE && this.meeting_data && this.meeting_data.id) {
        shareE = this.meeting_data.moments_share_img_path
      }
      let shareF = this.form.moments_share_content ? this.form.moments_share_content.replace(reg, "\r\n") : ''
      if (!shareF && this.meeting_data && this.meeting_data.id) {
        shareF = this.meeting_data.moments_share_content
      }

      this.WXConfig.wxShowMenu(
        data.payload,
        shareA,
        shareB,
        shareC,
        shareD,
        shareE,
        shareF);
    }
  }
}
</script>

<style lang="less" scoped>
.noMsg {
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: 10vh;
  justify-content: center;
  align-items: center;
  color: #dbdbdb;
  img {
    margin-bottom: 20px;
    width: 120px;
  }
}
.model {
  min-height: 100vh;
}
.articleBase {
  padding: 15px 20px;
  .articleBase_title {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 12px;
    color: #222222;
    line-height: 25px;
  }
  .color_art {
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 4px;
    color: #7f7f7f;
  }
  .articleBase_time {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #eff0f2;
  }
  img {
    width: 16px;
  }
}
.articleBase_content {
  margin-top: 16px;
}
</style>